import { useState, useEffect } from "react";
import CalendarSection from "./CalendarSection";
import RentalFormSection from "./RentalFormSection";
import axios from "axios";
import { useLocation } from "react-router-dom";

const RentalSchedule = () => {
  const [activeTab, setActiveTab] = useState("single");
  const [selectedField, setSelectedField] = useState("");
  const [selectedDates, setSelectedDates] = useState([]);
  const [currentMonth, setCurrentMonth] = useState(new Date().getMonth());
  const [currentYear, setCurrentYear] = useState(new Date().getFullYear());
  const [bookedDates, setBookedDates] = useState([]);
  const location = useLocation();

  const [formData, setFormData] = useState({
    eventType: "single",
    field: "",
    teamOne: "",
    teamTwo: "",
    numberOfMatches: "",
    numberOfTeams: "",
    bookedBy: {
      name: "",
      email: "",
      phone: "",
      organization: "",
      address: "",
      role: "",
    },
    notes: "",
  });

  useEffect(() => {
    if (location.state?.shouldScrollToCalendar) {
      const timer = setTimeout(() => {
        const calendarSection = document.getElementById(
          "schedule-rental-section"
        );
        if (calendarSection) {
          calendarSection.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }

        window.history.replaceState(
          { ...location.state, shouldScrollToCalendar: false },
          ""
        );
      }, 300);

      return () => clearTimeout(timer);
    }
  }, [location.state]);

  useEffect(() => {
    if (location.state && location.state.selectedField) {
      const field = location.state.selectedField;
      setSelectedField(field.fieldName);
      setFormData((prev) => ({
        ...prev,
        field: field._id,
      }));
      setSelectedDates([]);
    }

    const urlParams = new URLSearchParams(location.search);
    const fieldId = urlParams.get("fieldId");
    const fieldName = urlParams.get("fieldName");

    if (fieldId && fieldName) {
      setSelectedField(decodeURIComponent(fieldName));
      setFormData((prev) => ({
        ...prev,
        field: fieldId,
      }));
      setSelectedDates([]);
    }
  }, [location]);

  const fetchBookedEvents = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/events/all-events`
      );
      const events = res.data;

      let booked = [];

      events.forEach((event) => {
        if (event.field._id !== formData.field) return;

        if (event.eventType === "single" && event.matchDate) {
          booked.push(new Date(event.matchDate).toISOString().split("T")[0]);
        } else if (event.eventType === "tournament" && event.dateRange) {
          const start = new Date(event.dateRange.start);
          const end = new Date(event.dateRange.end);
          for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
            booked.push(new Date(d).toISOString().split("T")[0]);
          }
        }
      });

      setBookedDates(booked);
    } catch (err) {
      console.error("Error fetching events:", err);
    }
  };

  return (
    <div
      id="schedule-rental-section"
      className="tracking-wide flex flex-col lg:flex-row items-stretch justify-center gap-6 bg-gradient-to-r from-[#1a0630] to-[#0c052c] text-white px-4 md:px-8 py-8 md:py-10 shadow-2xl mb-10"
    >
      <CalendarSection
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        selectedField={selectedField}
        setSelectedField={setSelectedField}
        selectedDates={selectedDates}
        setSelectedDates={setSelectedDates}
        currentMonth={currentMonth}
        setCurrentMonth={setCurrentMonth}
        currentYear={currentYear}
        setCurrentYear={setCurrentYear}
        formData={formData}
        setFormData={setFormData}
        fetchBookedEvents={fetchBookedEvents}
        bookedDates={bookedDates}
      />
      <RentalFormSection
        activeTab={activeTab}
        selectedDates={selectedDates}
        formData={formData}
        setFormData={setFormData}
        fetchBookedEvents={fetchBookedEvents}
        setSelectedDates={setSelectedDates}
      />
    </div>
  );
};

export default RentalSchedule;